import React from "react";
import "./heroSection.css";

function HeroSection() {
  return (
    <section  id="home" className="hero-section-container">
      <div className="hero-section-overlay" />
      <div className="hero-section-content">
        <h1>
          Access Healthcare<br />
          <span>Anywhere. Anytime.</span>
        </h1>
        <p>
          Instantly book appointments, order medicines, or schedule lab tests from your phone with <strong>MediQNow</strong>.
        </p>
        <div className="hero-section-buttons">
          <button className="hero-section-btn-filled">Get Started</button>
          <button className="hero-section-btn-outline">Download App</button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
